import styled from 'styled-components';

export const Container = styled.div`
  .input-radio {
    label {
      padding: 0;
      border: none;
    }
    label span {
      border: none;
      padding: 5px;
      color: #8c8c8c;
    }
  }

  hr {
    height: 1px;
  }

  .add-representative {
    color: #ff6900;
  }
`;
